'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SubscriptionErrorView = require('./SubscriptionErrorView');

var _SubscriptionErrorView2 = _interopRequireDefault(_SubscriptionErrorView);

var _UpdateSubscriptionsView = require('./UpdateSubscriptionsView');

var _UpdateSubscriptionsView2 = _interopRequireDefault(_UpdateSubscriptionsView);

var _emailPreferenceService = require('./emailPreferenceService');

var _userConstants = require('../../../../common/users/userConstants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Components


// Actions


// Constants


var EmailUnsubscribe = function (_React$Component) {
    _inherits(EmailUnsubscribe, _React$Component);

    function EmailUnsubscribe(props) {
        _classCallCheck(this, EmailUnsubscribe);

        var _this = _possibleConstructorReturn(this, (EmailUnsubscribe.__proto__ || Object.getPrototypeOf(EmailUnsubscribe)).call(this, props));

        _this.loadPreferences = function () {
            _this.setState({
                loading: true
            });

            (0, _emailPreferenceService.getEmailPreferences)({ email: _this.props.email }).then(function (response) {
                _this.setState({
                    loading: false,
                    emailPreference: response.data.user.emailPreference
                });
            }).catch(function (err) {
                _this.setState({
                    error: err.data.error,
                    loading: false
                });
            });
        };

        _this.savePreferences = function (event) {
            event && event.preventDefault();

            var emailPreference = _this.state.emailPreference;


            var updatedEmailPreference = emailPreference ? _userConstants.EMAIL_PREFERENCE_BUFFER_BITS | emailPreference :
            // Hard set to zero if the user specifies they don't want any email notifications
            0;

            _this.setState({
                loading: true
            });

            (0, _emailPreferenceService.updateEmailPreferences)({ email: _this.props.email, emailPreference: updatedEmailPreference }).then(function (response) {
                _this.setState({
                    loading: false,
                    savedEmailPreference: emailPreference,
                    submitted: true,
                    dirty: false
                });
            }).catch(function (err) {
                _this.setState({
                    error: err.data.error,
                    loading: false
                });
            });
        };

        _this.updatePreference = function (event) {
            var emailPreference = _this.state.emailPreference;

            var updateBit = event.target.value;

            _this.setState({
                emailPreference: emailPreference ^ updateBit,
                dirty: true
            });
        };

        _this.clearError = function () {
            _this.setState({
                error: null
            });
        };

        _this.state = {
            error: null,
            loading: false,
            dirty: false,
            submitted: false,
            emailPreference: 0,
            // Initially start 'dirty' so the user can select to save their preferences
            savedEmailPreference: _userConstants.EMAIL_PREFERENCE_ALL
        };
        return _this;
    }

    _createClass(EmailUnsubscribe, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.loadPreferences();
        }
    }, {
        key: 'render',
        value: function render() {
            var error = this.state.error;


            var RenderComponent = error ? _SubscriptionErrorView2.default : _UpdateSubscriptionsView2.default;

            return _react2.default.createElement(RenderComponent, _extends({}, this.state, this.props, {
                updatePreference: this.updatePreference,
                savePreferences: this.savePreferences,
                error: error,
                clearError: this.clearError }));
        }
    }]);

    return EmailUnsubscribe;
}(_react2.default.Component);

exports.default = EmailUnsubscribe;


EmailUnsubscribe.propTypes = {
    email: _propTypes2.default.string,
    isGuest: _propTypes2.default.bool,
    dispatchNavigateToLogin: _propTypes2.default.func,
    dispatchNavigateToRootWorkspace: _propTypes2.default.func
};


//////////////////
// WEBPACK FOOTER
// ./src/client/user/account/settings/EmailUnsubscribe.js
// module id = 2082
// module chunks = 0